import { useRef } from 'react';
import useScrollAnimation from '../hooks/useScrollAnimation';
import { services1, services2, services3, services4, services5, services6, services7, services8 } from "../helper/utils";

const ServiceItem = ({ service, isEven }) => {
    const ref = useRef(null);
    useScrollAnimation([ref]);

    return (
        <div ref={ref} className="services-div animate-on-scroll" style={{ flexDirection: isEven ? 'row-reverse' : 'row' }}>
            <img src={service.img} alt={`Services ${service.id}`} className="service-img" />

            <div style={{ flex: 1, position: 'relative' }}>
                <div className="services-relative">
                    <p className="box-blog-huge-text very-huge-text" >{service.id}</p>
                </div>

                <div className="services-details">
                    <p className="services-title">{service.title}</p>
                    <p className="aboutus-text-details">{service.description}</p>
                </div>
            </div>
        </div>
    );
};

const Services = () => {
    const titleRef = useRef(null);
    const footerRef = useRef(null);

    useScrollAnimation([titleRef, footerRef]);

    const servicesData = [
        { id: 1, title: "collection of fabric", description: "A curated collection of high-quality fabrics available for purchase to create custom garments.", img: services1 },
        { id: 2, title: "Bespoke Tailoring", description: "Experience the luxury of custom-made clothing, crafted to your exact specifications. Whether it's a suit for a special occasion or everyday wear, we ensure a perfect fit and impeccable finish.", img: services2 },
        { id: 3, title: "Corporate Dress Tailor", description: "Professional tailoring services for corporate clients, ensuring a perfect fit and impeccable finish for business attire.", img: services4 },
        { id: 4, title: "custom designs", description: "Have a unique design in mind? Our expert designers work with you to create custom garments that reflect your personal style. From sketches to final fittings, we make your vision a reality.", img: services3 },
        { id: 5, title: "Accessories", description: "Complete your look with our selection of stylish accessories, including ties, cufflinks, pocket squares, and more.", img: services5 },
        { id: 6, title: "Style Consultation", description: "Receive personalized style advice from our experienced consultants. We help you choose the right fabrics, designs, and accessories to match your taste and occasion.", img: services6 },
        { id: 7, title: "Ready-made Kurtas", description: "Discover our range of high-quality, ready-made kurtas available in various styles and sizes. Perfect for any occasion.", img: services7 },
        { id: 8, title: "Wedding & Event Attire", description: "Look your best for weddings and special events with our custom-tailored sherwani, Jodhpuri suits, and other formal wear. We ensure you stand out on your big day.", img: services8 }
    ];

    return (
        <div className="max-width-about-class main-class">
            <p ref={titleRef} className='get-in-touch-text-services animate-on-scroll'>Services</p>
            <div className='line-separator-contact-page'></div>

            <div className="services-list">
                {servicesData.map((service, index) => (
                    <ServiceItem key={service.id} service={service} isEven={index % 2 !== 0} />
                ))}
            </div>

            {/* Get In Touch */}
            <div className='max-width-class' style={{ marginBottom: '55px' }}>
                <div ref={footerRef} className='get-in-touch-card-services animate-on-scroll'>
                    <p className='get-in-touch-text-huge'>Discover the art of bespoke tailoring.</p>
                    <div className='get-in-touch-text-container'>
                        <div className='line-separator-contact'></div>

                        <div className="services-bottom-div">
                            <p className='get-in-touch-text-two'>get in touch to explore our services or schedule a visit today.</p>
                            <div className="get-in-touch-btn-wrapper">
                                <button className="hero-btn" onClick={() => { window.location.href = 'tel:09909102266' }}>Book a fitting</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </div>
    );
};

export default Services;
